$(document).ready(function() {
    $(document).on('click', '.localization-wrapper .icon--text-bar:nth-child(1) a,.localization-wrapper-moble .icon--text-bar:nth-child(1) a , .click_popup_store', function(e) {
        $('#popup_wo_gibts_giesinger').fadeIn();
        e.preventDefault();
    });
    

    $(document).on('click', '.nt_giesinger .subtitle a ', function(e) {
         $('#popup_store').fadeIn();
          e.preventDefault();
    });

    $(document).on('click', '.localization-wrapper .icon--text-bar:nth-child(2) a,.localization-wrapper-moble .icon--text-bar:nth-child(2) a', function(e) {
        $('#popup_store').fadeIn();
        e.preventDefault();
    });
    $(document).on('click', '.close_popup', function(e) {
        $(this).closest('.popup_store').fadeOut();
    });
    $(document).on('click', '.popup_store', function(e) {
        if ($(e.target).is('.popup_store')) {
            $('.popup_store').fadeOut();
        }
    });
     $(document).on('click', 'a.button.button--secondary', function(e) {
        if($(this).attr("href") == '#offnungszeiten'){
            e.preventDefault();
            $('#popup_offnungszeiten').fadeIn();
        }
        
    });
});